import type { Theme } from '../../themes/themes';

export const createLoadingDotsTheme = (): Partial<Theme> => ({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@globalLoadingDots': `
          {};
            
          @keyframes loadingDots {
              0% {
                 opacity: 1;
                 transform: scale(1.0);
               }
              70% {
                opacity: 0.75;
                transform: scale(0.5);
              }
              100% {
                opacity: 1;
                transform: scale(1.0);
              }          
          }
        `,
      },
    },
  },
});
